/*
 * @Author: Json Chen
 * @Date: 2021-06-26 22:30:01
 * @LastEditTime: 2022-06-02 14:23:32
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Product/Hooks/useProductSettings.ts
 */
import { getProductSetting } from '@/src/request/settings/product';
import { useRequest } from 'ahooks';
import React from 'react';
import { ProductPriceTier } from '../type';

const useProductSettings = (disabled?: boolean) => {
  const [reviewAccepted, setReviewAccepted] = React.useState<boolean>(false);
  const [reviewDisplayed, setReviewDisplayed] = React.useState<boolean>(false);

  const [priceTierList, setPriceTierList] = React.useState<ProductPriceTier[]>(
    [],
  );

  const [priceTierDefaultCurrency, setPriceTierDefaultCurrency] =
    React.useState<string>('');
  const [priceTierCurrencyOptions, setPriceTierCurrencyOptions] =
    React.useState([]);

  const [defaultAttrTableData, setDefaultAttrTableData] = React.useState([]);

  const [productAttributes, setProductAttributes] = React.useState([]);

  const { loading, run: _getProductSetting } = useRequest(getProductSetting, {
    manual: true,
    onSuccess: (data) => {
      const { currencies, reportingCurrency, productSetting } = data || {};

      const {
        brands = [],
        defaultMeasurementUnits = [],
        storeMeasurementUnits = [],
        suppliers = [],
        priceTiers = [],
        productAttributes = [],
        reviewAccepted,
        reviewDisplayed,
      } = productSetting || {};

      setReviewAccepted(reviewAccepted);
      setReviewDisplayed(reviewDisplayed);
      setPriceTierDefaultCurrency(reportingCurrency || '');
      setPriceTierCurrencyOptions(currencies || []);
      setPriceTierList(priceTiers || []);
      setProductAttributes(productAttributes || []);
      setDefaultAttrTableData([
        {
          title: 'Product Brands',
          options: brands,
          inputKey: 'name',
          newOptionName: 'Brand name',
        },
        {
          title: 'Unit of Measurement',
          defaultOptions: defaultMeasurementUnits,
          options: storeMeasurementUnits,
          inputKey: 'unit',
          newOptionName: 'unit',
        },
        {
          title: 'Supplier',
          options: suppliers,
          inputKey: 'name',
          newOptionName: 'Supplier',
        },
      ]);
    },
  });

  React.useEffect(() => {
    if (!disabled) {
      _getProductSetting();
    }
  }, []);

  return {
    loading,
    reviewAccepted,
    reviewDisplayed,
    priceTierList,
    priceTierDefaultCurrency,
    priceTierCurrencyOptions,
    defaultAttrTableData,
    productAttributes,
  };
};
export default useProductSettings;
